module.exports = __webpack_public_path__ + "img/jeep_thumbnail.80a696ed.png";